import styled from 'styled-components'

export const StateRoot = styled.section`
    min-height: 360px;
    padding: 64px 24px;
    border-top: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
`;

export const StateTitle = styled.h2`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.025em;
`;

export const StateDescription = styled.p`
    max-width: 470px;
    margin: 0 0 15px;
    color: ${({ theme }) => theme.palette.colors.muted};
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.6;
`;
